import { render, staticRenderFns } from "./AppBadge.vue?vue&type=template&id=47031950&scoped=true"
import script from "./AppBadge.vue?vue&type=script&lang=js"
export * from "./AppBadge.vue?vue&type=script&lang=js"
import style0 from "./AppBadge.vue?vue&type=style&index=0&id=47031950&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47031950",
  null
  
)

export default component.exports